import script from "./SliderOptionDeleteBoxed.vue?vue&type=script&setup=true&lang=ts"
export * from "./SliderOptionDeleteBoxed.vue?vue&type=script&setup=true&lang=ts"

import "./SliderOptionDeleteBoxed.vue?vue&type=style&index=0&id=5c9853dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c9853dd"]])

export default __exports__